import { createAsyncThunk, createSlice, isAsyncThunkAction } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import fetchAPI from '../../../common/fetchAPI'
import { LicenseActivationStateClass } from "./interfaces/LicenseActivationStateClass";

const initialState: LicenseActivationStateClass = {
    isLoading: false,
    licenseActivationList: [],
    status: "idle",
    selectedRecord: {},
    isReload: false,
    isValidLicenseActivation:false,
    expiryDateLicense:"",
    isFreeAccount:false,
    rowscount:0,
    numberOfUsersAllowed:0,
    DISABLE_LICENSE:"",
    applicationMode:"",
    isFreeLiteVersion:false,
    isPaidCustomerLicenseExpired:false,
    isHostedPaidCustomerLicenseExpired:false,
    cancellationURL:"",
    IsHostedPaidCustomer:false,
    SelectedCurrentHostedPackage:"",
    IsUpgradeExistingPlan: false,
    PackagesData:[],
    MachineId: ''

};

interface IThunkApi {
    state: {
        licenseActivation: LicenseActivationStateClass
    }
};

export const getLicenseActivationAndPageLoadDataAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "LicenseActivation/v2/getLicenseActivationAndPageLoadData",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/LicenseActivation/PageLoad', 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )
    
export const changePlanToAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "LicenseActivation/v2/changePlanTo",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/LicenseActivation/ChangePlanTo/'+arg, 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )


export const ChangeUpdateExistingPlanAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "LicenseActivation/v2/changeUpdateExistingPlan",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/LicenseActivation/ChangeUpdateExistingPlan/'+arg, 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

export const RenewAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "LicenseActivation/v2/Renew",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/LicenseActivation/Renew', 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )


export const activateAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'LicenseActivation/v2/activate',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/LicenseActivation/Activate', 'POST', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

export const licenseActivationSlice = createSlice({
    name: 'licenseActivation',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        }
    },

    extraReducers: (builder) => {
        builder
            .addCase(getLicenseActivationAndPageLoadDataAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getLicenseActivationAndPageLoadDataAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                //console.log("getLicenseActivationAndPageLoadDataAsync:",payload);
                if (Object.keys(payload.Data).length === 0) {
                    state.licenseActivationList = [];
                } else {
                    state.licenseActivationList = payload.Data;
                    state.licenseActivationList.map((item: any) => {
                        // item.MachineId = payload.machineId
                        state.MachineId = item.MachineId
                    });
                    state.selectedRecord = state.licenseActivationList[0];
                    state.isValidLicenseActivation = payload.isValidLicenseActivation;
                    state.expiryDateLicense = payload.expiryDateLicense;
                    state.isFreeAccount = payload.isFreeAccount;
                    state.rowscount = payload.rowscount;
                    state.numberOfUsersAllowed = payload.numberOfUsersAllowed;
                    state.DISABLE_LICENSE = payload.DISABLE_LICENSE;
                    state.applicationMode = payload.applicationMode;
                    state.isFreeLiteVersion = payload.isFreeLiteVersion;
                    state.isPaidCustomerLicenseExpired = payload.isPaidCustomerLicenseExpired;
                    state.isHostedPaidCustomerLicenseExpired = payload.isHostedPaidCustomerLicenseExpired;
                    state.cancellationURL = payload.cancellationURL;
                    state.IsHostedPaidCustomer = payload.IsHostedPaidCustomer;
                    state.SelectedCurrentHostedPackage = payload.SelectedCurrentHostedPackage;
                    state.IsUpgradeExistingPlan = payload.IsUpgradeExistingPlan;
                    state.PackagesData = payload.PackagesData;
                }
                state.isReload = false;
                state.isLoading = false;
            })
            .addCase(getLicenseActivationAndPageLoadDataAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(RenewAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(RenewAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                //console.log('payload:',payload.RenewURL);
                state.isReload = false;
                state.isLoading = false;
            })
            .addCase(RenewAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(changePlanToAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(changePlanToAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                //console.log('payload:',payload.ChangePlanToPaymentURL);
                state.isReload = false;
                state.isLoading = false;
            })
            .addCase(changePlanToAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(ChangeUpdateExistingPlanAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(ChangeUpdateExistingPlanAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                //console.log('payload:',payload.PaymentURL);
                state.isReload = false;
                state.isLoading = false;
            })
            .addCase(ChangeUpdateExistingPlanAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(activateAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(activateAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                //console.log('activateAsync:',payload);
                state.isLoading = false;
            })
            .addCase(activateAsync.rejected, (state) => {
                state.status = 'failed';
            })
    }

});

export const { resetSelectedRecordObjectInState } = licenseActivationSlice.actions
export const licenseActivationState = (state: RootState) => state.licenseActivation
export default licenseActivationSlice.reducer
